export default "__VITE_PUBLIC_ASSET__3c2acf09__"